import {EventBroker} from "@frontend/lib/utils/event-broker";

export const FIGMA_LAYERS_EVENTS = {
  INIT: 'INIT',
  FILL_TEMPLATE: 'FILL_TEMPLATE'
}

export const figmaLayersEventBroker = new EventBroker();
